import React from 'react'
import ListItemStyle from './ListItemStyle/ListItemStyle'

const ListItem = ({children}) => (
    <ListItemStyle>
        <a href={children.link} target="_blanc"><img src={children.icon} alt={children.name} /></a>
    </ListItemStyle>
)

export default ListItem